<div class="st-form">
  <app-st-impersonation-floating-banner [impersonatedEmail]="this.impersonatedEmail"
                                        [username]="this.username"
                                        [roleName]="this.consultantRoleName"
                                        (exitViewAs)="this.onExitViewAs($event)"
  >

  </app-st-impersonation-floating-banner>
</div>
<div id="saved-search-modal-id" class="modal">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="modal-header">
      <span class="close" (click)="closeSavedSearchModal()">&times;</span>
      <br>
      <div *ngIf="showErrorMessages" class="container st-form text-danger" #goUp>
        <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
        <div *ngFor="let errorMsg of errorMessages" class="alert alert-danger" role="alert">
          <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
        </div>
        <br>
      </div>
      <div *ngIf="showSuccessMessages" class="container st-form text-danger" #goUp>
        <div *ngFor="let successMsg of successMessages" class="alert alert-success" role="alert">
          <b>{{successMsg.field}}:</b> {{successMsg.detail}}
        </div>
        <br>
      </div>
      <br>
    </div>
    <div class="modal-body">
      <app-st-input-text [idVal]="'saved-search-name-text-id'" [label]="''" [placeHolderVal]="'Saved Search Name'" [width]="'95%'"></app-st-input-text>
    </div>
    <br>
    <div class="modal-footer">
      <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
        <app-st-button-white [idVal]="'saved-search-modal-save-button-id'" [label]="'Save'" [primary]="true"
                       (click)="this.onSearch(true)"></app-st-button-white>
        <app-st-button-white [idVal]="'saved-search-modal-close-button-id'" [label]="'Close'" [primary]="false"
        (click)="closeSavedSearchModal()"></app-st-button-white>

      </div>
    </div>
  </div>
</div>

<div id="mySidenav" class="sidenav">
  <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>
  <app-st-header-title [inputVal]="'Search Filters'" [color]="'#FFFFFF'"></app-st-header-title>
  <div *ngIf="!this.platform.includes('android') && !this.platform.includes('iphone')" class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end sidenavExtButton">
      <app-st-button *ngIf="!this.isSideNavOpened" [idVal]="'sidenav-ext-button-id'" [label]="'< Search Filters'" [primary]="true"
                     (click)="toggle()"></app-st-button>
    </div>
  </div>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-white [idVal]="'reset-filter-modal-close-button1-id'" [label]="'Reset Filter'" [primary]="false"
                     (click)="resetAllFiltersModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'saved-search-modal-button1-id'" [label]="'Save'" [primary]="false"
                     (click)="openSavedSearchModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'top-search-button-id'" [label]="'Search'" [primary]="true"
                     (click)="this.onSearch(false)"></app-st-button-white>
    </div>
  </div>
  <div *ngIf="showSideNavErrorMessages" class="container st-form text-danger" #goUp>
    <br>
    <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
    <div *ngFor="let errorMsg of sideNavErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <div *ngIf="showSideNavSuccessMessages" class="container st-form text-danger" #goUp>
    <div *ngFor="let successMsg of sideNavSuccessMessages" class="alert alert-success" role="alert">
      <b>{{successMsg.field}}:</b> {{successMsg.detail}}
    </div>
    <br>
  </div>
  <br>
  <!--https://getbootstrap.com/docs/4.0/components/modal/-->
  <!--Modal for saving the saved search-->
  <app-st-select [idVal]="'saved-search-selector-id'" [defaultOption]="'Select Saved Search'" [label]="''" [idKey]="'savedSearchId'" [displayKey]="'savedSearchName'" [valueKey]="'savedSearchId'" [inputArray]="this.savedSearchArray" ></app-st-select>
  <br>
  <app-st-button-white [idVal]="'top-apply-saved-search-button-id'" [label]="'Apply Saved Search'" [primary]="true"
                 (click)="this.onApplySavedSearch()"></app-st-button-white>
  <br>
  <br>
  <div>
    <button id="'tax-years-button-id'" class="accordion" (click)="this.toggleTaxYearsFilter()">Tax Year Based on Filing Status<b *ngIf="!this.taxYearsButton"> + </b><b *ngIf="this.taxYearsButton"> - </b></button>
    <br>
  </div>
  <div *ngIf="this.taxYearsButton" class="panel">
    <div class="accordion-body" *ngFor="let taxYearsRadioButton of taxYearsRadioButtons; let i9 = index">
      <div class="form-check">
        <input class="form-check-input" type="radio" value="{{taxYearsRadioButton['taxYear']}}" id="flexRadioTaxYears-{{i9}}"
               (click)="trackTaxYears(i9)" [checked]="taxYearsRadioButton['checked']">
        <label class="form-check-label checkbox-text" for="flexRadioTaxYears-{{i9}}">
          {{taxYearsRadioButton['taxYear']}}
        </label>
      </div>
    </div>
  </div>
  <br>
  <app-st-span [inputVal]="'Include Grant Recipient Names: '" class="webtext-black-bold"></app-st-span><br>
  <app-st-span [inputVal]="'Include Name\'s legal name and accuracy are important. Separate multiple grant recipient names by commas.'"></app-st-span>
  <app-st-input-text [idVal]="'search-grant-names-text-id'" [label]="''" [placeHolderVal]="'Search Grant Recipient Names'" [maxLength]="200" [width]="'95%'"></app-st-input-text>
  <!--<app-st-autocomplete [idVal]="'search-grant-names-text-id'" [label]="''" [placeHolderVal]="'Include Grant Recipient Names'" [maxLength]="200" [width]="'95%'"
                       [items]="this.recipientNamesAutocomplete"
  ></app-st-autocomplete>-->
  <br>
  <app-st-span [inputVal]="'Include EINs: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple eins by commas.'"></app-st-span>
  <app-st-input-text [idVal]="'eins-text-id'" [label]="''" [placeHolderVal]="'Include EINs'" [maxLength]="200" [width]="'95%'"></app-st-input-text>
  <br>
  <app-st-span [inputVal]="'Include Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
  <!--<app-st-input-text [idVal]="'cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'"></app-st-input-text>-->
  <app-st-autocomplete-key-lookup [idVal]="'cities-text-id'" [label]="''" [placeHolderVal]="'Include Cities'" [maxLength]="200" [width]="'95%'" [keyLookup]="'city'"
                                  [items]="this.citiesAutocomplete"
  ></app-st-autocomplete-key-lookup>
  <br>
  <!--
  <app-st-span [inputVal]="'Exclude Cities: '" class="webtext-black-bold"></app-st-span><app-st-span [inputVal]="'Separate multiple cities by commas.'"></app-st-span>
  <app-st-input-text [idVal]="'cities-without-text-id'" [label]="''" [placeHolderVal]="'Exclude Cities'" [maxLength]="200" [width]="'95%'"></app-st-input-text>
  <br>-->
  <app-st-span [inputVal]="'State: '" class="webtext-black-bold"></app-st-span>
  <app-st-select [idVal]="'usa-dropdown-list-id'" [defaultOption]="'Select State'" [label]="''" [idKey]="'usaStateId'" [displayKey]="'usaState'" [valueKey]="'usaState'" [inputArray]="this.statesList"></app-st-select>
  <br>

  <!--Cause Dropdown triggers the Giving Interest Dropdown-->
  <app-st-span [inputVal]="'Cause Category: '" class="webtext-black-bold"></app-st-span><br>
  <app-st-select [idVal]="'cause-category-dropdown-list-id'" [defaultOption]="'Cause Category'" [label]="''" [idKey]="'causeId'" [displayKey]="'causeDisplayName'" [valueKey]="'causeName'" [inputArray]="this.causeDropdownList" (change)="updateCauseGivingInterestsDropdown()"></app-st-select>
  <br>
  <app-st-span [inputVal]="'Select the option of your search for the selected Cause Category Giving Interest: '" class="webtext-black-bold"></app-st-span>
  <div>
    <input class="form-check-input radio-button-properties" type="radio" value="'AND'" id="flexRadioAND3"
           (click)="trackLogicalExpression('AND')" [checked]="logicalOperatorAnd">
    <label class="form-check-label checkbox-text webtext-black" for="flexRadioAND3">
      &nbsp;AND
    </label>
    &nbsp;&nbsp;
    <input class="form-check-input radio-button-properties" type="radio" value="'OR'" id="flexRadioOR3"
           (click)="trackLogicalExpression('OR')" [checked]="logicalOperatorOr">
    <label class="form-check-label checkbox-text webtext-black" for="flexRadioOR3">
      &nbsp;OR
    </label>
  </div>
  <br>
  <!--Giving Interest Dropdown-->
  <app-st-span [inputVal]="'Cause Category Giving Interests: '" class="webtext-black-bold"></app-st-span><br>
  <app-st-select [idVal]="'cause-giving-interests-dropdown-list-id'" [defaultOption]="'Select your Cause Category Giving Interest'" [label]="''" [idKey]="'causeGivingInterestId'" [displayKey]="'givingInterestDisplayName'" [valueKey]="'givingInterestName'" [inputArray]="this.causeGivingInterestsDropdownList"></app-st-select>
  <br>
  <div class="col2 d-grid gap-2 d-md-flex">
    <app-st-button-white [idVal]="'cause-giving-interests-include-button-id'" [label]="'Add (+)'" [primary]="true"
                   (click)="this.addCauseGivingInterestFilter2(true)"></app-st-button-white>
  </div>
  <br>
  <!--Include these cause_giving_interests-->
  <br>

  <i class="webtext-black" style="font-size: 12px;">As you add your Cause Category Giving Interests, the list below will populate.</i>
  <div>
    <table class="table table-striped webtext-black" style="width:95%; border-radius: 10px">
      <thead>
      <tr>
        <th style="width:85%">Cause Category Giving Interests Query</th>
        <th style="width:15%">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of this.causeGivingInterestsList">
        <td>{{row}}</td>
        <td>
          <a *ngIf="('OR' != row) && ('AND' != row)" (click)="onDeleteGivingInterest(row)">
            <i class="bi bi-trash"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <br>
  <br>
  <!--Exclude these cause_giving_interests-->
  <!--
  <div>
    <br>
    <table class="table table-striped webtext-black" style="width:95%">
      <thead>
      <tr>
        <th style="width:85%">Exclude these Cause Category Giving Interest (s)</th>
        <th style="width:15%">Action</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let row of this.causeGivingInterestsWithoutList">
        <td>{{row}}</td>
        <td>
          <a (click)="onDeleteGivingInterestWithout(row)">
            <i class="bi bi-trash"></i>
          </a>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <br>-->

  <app-st-span [inputVal]="'Minimum Grant Amount: '" class="webtext-black-bold"></app-st-span>
  <app-st-input-text [idVal]="'grant-amt-min-text-id'" [label]="''" [placeHolderVal]="'Min Grant Amount'" [maxLength]="20" [width]="'46%'"></app-st-input-text>
  <br>
  <app-st-span [inputVal]="'Maximum Grant Amount: '" class="webtext-black-bold"></app-st-span>
  <app-st-input-text [idVal]="'grant-amt-max-text-id'" [label]="''" [placeHolderVal]="'Max Grant Amount'" [maxLength]="20" [width]="'46%'"></app-st-input-text>
  <br>

  <div>
    <app-st-span [inputVal]="'Sort By Recipient Name: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="recipient-name-asc-radio-button-id"
                     (click)="toggleRecipientNameAscButton()" [checked]="this.recipientNameAscRadioButton">
      <!--<app-st-span [inputVal]="'Ascending'"></app-st-span>-->
      <label class="form-check-label checkbox-text webtext-black" for="recipient-name-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="recipient-name-desc-radio-button-id"
                   (click)="toggleRecipientNameDescButton()" [checked]="this.recipientNameDescRadioButton">
      <!--<app-st-span [inputVal]="'Descending'"></app-st-span>-->
      <label class="form-check-label checkbox-text webtext-black" for="recipient-name-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By City: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-asc-radio-button-id"
             (click)="toggleCityAscButton()" [checked]="this.cityAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="city-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="city-desc-radio-button-id"
             (click)="toggleCityDescButton()" [checked]="this.cityDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="city-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By State: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-asc-radio-button-id"
             (click)="toggleStateAscButton()" [checked]="this.stateAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="state-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="state-desc-radio-button-id"
             (click)="toggleStateDescButton()" [checked]="this.stateDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="state-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
    </div>
  </div>
  <br>
  <div>
    <app-st-span [inputVal]="'Sort By Grant Amount: '" class="webtext-black-bold"></app-st-span>
    <div>
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="grant-amt-asc-radio-button-id"
             (click)="toggleGrantAmountAscButton()" [checked]="this.grantAmountAscRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="grant-amt-asc-radio-button-id">
        &nbsp;ASCENDING
      </label>
      &nbsp;&nbsp;&nbsp;&nbsp;
      <input class="form-check-input radio-button-properties" type="radio" value="false" id="grant-amt-desc-radio-button-id"
             (click)="toggleGrantAmountDescButton()" [checked]="this.grantAmountDescRadioButton">
      <label class="form-check-label checkbox-text webtext-black" for="grant-amt-desc-radio-button-id">
        &nbsp;DESCENDING
      </label>
      </div>
  </div>
  <!--
  <div>
    <br>
    <div class="chip" *ngFor="let row of this.causeGivingInterestsWithoutList">
      {{row}}
      <span class="closebtn-chip" (click)="this.deleteGivingInterestWithoutChip3(row)">&times;</span>
    </div>
  </div>-->
  <br>
  <br>
  <div *ngIf="showSideNavErrorMessages" class="container st-form text-danger" #goUp>
    <br>
    <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
    <div *ngFor="let errorMsg of sideNavErrorMessages" class="alert alert-danger" role="alert">
      <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
    </div>
    <br>
  </div>
  <br>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <app-st-button-white [idVal]="'reset-filter-modal-close-button2-id'" [label]="'Reset Filter'" [primary]="false"
                     (click)="resetAllFiltersModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'saved-search-modal-button2-id'" [label]="'Save'" [primary]="false"
                     (click)="openSavedSearchModal()"></app-st-button-white>
      <app-st-button-white [idVal]="'bottom-search-button-id'" [label]="'Search'" [primary]="true"
                     (click)="this.onSearch(false)"></app-st-button-white>
    </div>
  </div>
  <br>
  <div class="container st-form">
    <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
      <a href="javascript:void(0)" class=".closebtn-bottom" (click)="closeNav()">&times;</a>
    </div>
  </div>
  <br>
</div>

<app-st-banner [idVal]="'banner-id'" [breadCrumbs]="this.breadCrumbs"
               [hasElementTags]="false" [elementTags]="[]" [requiresSignOutButton]="true"
></app-st-banner>
<br><br><br><br><br>
<div class="container-xxl">
    <div class="row pt-4 pb5">
      <div class="col-2 d-flex justify-content-center neg-margin">
        <!--<app-st-profile-picture></app-st-profile-picture>-->
      </div>
      <div class="col-8">
        <app-st-header-title [inputVal]="pageName"></app-st-header-title>
        <br>
        <div *ngIf="showPageErrorMessages" class="container st-form text-danger" #goUp>
          <app-st-span [inputVal]="'Please validate the following: '"></app-st-span>
          <div *ngFor="let errorMsg of pageErrorMessages" class="alert alert-danger" role="alert">
            <b>{{errorMsg.field}}:</b> {{errorMsg.detail}}
          </div>
          <br>
        </div>
        <div *ngIf="showPageSuccessMessages" class="container st-form text-success" #goUp>
          <div *ngFor="let successMsg of pageSuccessMessages" class="alert alert-success" role="alert">
            <b>{{successMsg.field}}:</b> {{successMsg.detail}}
          </div>
          <br>
        </div>
        <br>
        <!--<span style="font-size:30px;cursor:pointer" (click)="openNav()">&#9776; Filters</span>-->
        <app-st-button-filter [idVal]="'filter-button-id'" [label]="'Search Filters'"
                              (click)="this.openNav()"></app-st-button-filter>
        &nbsp;&nbsp;
        <app-st-button-delete-all [idVal]="'clear-results-button-id'" [label]="'Clear Results'"
                                  (click)="this.clearResultsAndFilter()"></app-st-button-delete-all>
        <br>
        <br>

        <div class="col2 d-grid gap-2 d-md-flex justify-content-md-end align-items-end">
          <app-st-button *ngIf="(this.subscriptionActive && !this.customerTrialVerified)"
                         [idVal]="'top-export-to-excel-button-id'" [label]="'Download Your Results to CSV'" [primary]="true"
                         (click)="this.onExportToExcel()"
          ></app-st-button>
        </div>
        <app-st-pagination2 [idVal]="'search-grants-pagination-id'" [collectionSize]="this.collectionSize"
                            [currentPage]="this.page" [pageSize]="100" [maxPagesDisplayed]="7"
                            [customPageSizes]="this.customPageSizes"
                            (pageChange)="changePageResults($event)" #grantspaginator
        ></app-st-pagination2>
        <!--
        <app-search-grants-listing *ngIf="!loadingIcon; else loadingPage" [rows]="rows"
        ></app-search-grants-listing>-->

        <table class="table table-striped webtext-black" *ngIf="!loadingIcon; else loadingPage">
          <thead>
          <tr>
            <th style="width:35%">Recipient of Grant
              <app-st-button-sort-text-asc *ngIf="this.sortedAscRecipientOfGrantHeaderButton" [idVal]="'sort-recipient-of-grant-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextRecipientOfGrantName()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscRecipientOfGrantHeaderButton" [idVal]="'sort-recipient-of-grant-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextRecipientOfGrantName()">

              </app-st-button-sort-text-desc>
            </th>
            <th style="width:15%">City
              <app-st-button-sort-text-asc *ngIf="this.sortedAscCityHeaderButton" [idVal]="'sort-city-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscCityHeaderButton" [idVal]="'sort-city-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

              </app-st-button-sort-text-desc>
            </th>
            <th style="width:15%">State
              <app-st-button-sort-text-asc *ngIf="this.sortedAscStateHeaderButton" [idVal]="'sort-state-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextState()">

              </app-st-button-sort-text-asc>
              <app-st-button-sort-text-desc *ngIf="!this.sortedAscStateHeaderButton" [idVal]="'sort-state-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextState()">

              </app-st-button-sort-text-desc>
            </th>
            <th style="width:30%">Donor Name</th>
            <th style="width:15%">Grant Amount
              <app-st-button-sort-number-asc *ngIf="this.sortedAscCashGrantAmtHeaderButton" [idVal]="'sort-cash-grant-amt-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberCashGrantAmt()">

              </app-st-button-sort-number-asc>
              <app-st-button-sort-number-desc *ngIf="!this.sortedAscCashGrantAmtHeaderButton" [idVal]="'sort-cash-grant-amt-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberCashGrantAmt()">

              </app-st-button-sort-number-desc>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of rows">
            <td>{{row['recipientOfGrantName']}}&nbsp;<i class="bi bi-search btn" (click)="onViewGrantDetails(row)"></i></td>
            <td>{{row['recipientOfGrantCity']}}</td>
            <td>{{row['recipientOfGrantState']}}</td>
            <td>{{row['donorName']}}</td>
            <td>{{row['cashGrantAmtFormatted']}}</td>
          </tr>
          </tbody>
        </table>
        <br>
        <app-st-button-back-to-top></app-st-button-back-to-top>
        <br>
        <br>
        <ng-template #loadingPage >
          <div class="d-flex justify-content-center">
            <br>
            <br>
            <div class="spinner-grow text-info" role="status">
              <span class="visually-hidden webtext-black">Loading...</span>
            </div>
          </div>
        </ng-template>

      </div>
    </div>
</div>
